import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { parseSettings } from 'api/getSettings';

const mutation = gql`
mutation UpdateSettings($settings: [SettingsParam]) {
  updateAllSettings(settings: $settings) {
    id
    key
    value
    type
    kind
  }
}`;

export function convertSettings(settings) {
  return Object.keys(settings).map((name) => ({
    id: settings[name].id,
    key: settings[name].key,
    value: settings[name].value.toString(),
    type: settings[name].type,
    kind: settings[name].kind,
  }));
}

function updateSettings(settings) {
  return apollo.client.mutate({
    mutation,
    variables: {
      settings: convertSettings(settings),
    },
  }).then((res) => parseSettings(res.data.updateAllSettings));
}

export default updateSettings;
